"use client";

import * as React from "react";
import Image from "next/image";
import {
    Box,
    Chip,
    Container,
    Grid,
    Stack,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from "@mui/material";
import CarInvestmentCard, { CarInvestmentCardProps } from "./CarInvestmentCard";
import Heading from "../heading";
import EnquireFormModal from '../../components/all-services/enquiryForm'

// const CAR_DATA = [
//     {
//         id: 1,
//         segment: "Sedan",
//         title: "Mercedes Benz S 500",
//         image: "/img/investments/car.jpg", // swap to your asset
//         stats: [
//             { label: "Down Payment", value: "160,450" },
//             { label: "Income Per Month", value: "160,450" },
//             { label: "Monthly Installment", value: "21,512" },
//         ],
//         price: "7,000 AED",
//         period: "/Per Month",
//     },
//     // duplicate entries for layout demo
//     {
//         id: 2, segment: "Sedan", title: "Mercedes Benz S 500", image: "/img/investments/car.jpg", stats: [
//             { label: "Down Payment", value: "160,450" },
//             { label: "Income Per Month", value: "160,450" },
//             { label: "Monthly Installment", value: "21,512" },
//         ], price: "7,000 AED", period: "/Per Month"
//     },
//     {
//         id: 3, segment: "SUVs", title: "Mercedes Benz S 500", image: "/img/investments/car.jpg", stats: [
//             { label: "Down Payment", value: "160,450" },
//             { label: "Income Per Month", value: "160,450" },
//             { label: "Monthly Installment", value: "21,512" },
//         ], price: "7,000 AED", period: "/Per Month"
//     },
//     {
//         id: 4, segment: "Sedan", title: "Mercedes Benz S 500", image: "/img/investments/car.jpg", stats: [
//             { label: "Down Payment", value: "160,450" },
//             { label: "Income Per Month", value: "160,450" },
//             { label: "Monthly Installment", value: "21,512" },
//         ], price: "7,000 AED", period: "/Per Month"
//     },
//     {
//         id: 5, segment: "SUVs", title: "Mercedes Benz S 500", image: "/img/investments/car.jpg", stats: [
//             { label: "Down Payment", value: "160,450" },
//             { label: "Income Per Month", value: "160,450" },
//             { label: "Monthly Installment", value: "21,512" },
//         ], price: "7,000 AED", period: "/Per Month"
//     },
//     {
//         id: 6, segment: "Sedan", title: "Mercedes Benz S 500", image: "/img/investments/car.jpg", stats: [
//             { label: "Down Payment", value: "160,450" },
//             { label: "Income Per Month", value: "160,450" },
//             { label: "Monthly Installment", value: "21,512" },
//         ], price: "7,000 AED", period: "/Per Month"
//     },
// ];

// const FILTERS = ["All", "Sedan", "SUVs"];

const INITIAL_STATE = {
    vehicle: '',
    initial: '',
    monthly: '',
    month: ''
}

export default function PickYourCarGrid({ data, onClick }) {
    const { title, subtitle, filters, carData } = data;
    const [filter, setFilter] = React.useState("All");
    const [contact, setContact] = React.useState(INITIAL_STATE)
    const [openEnquire, setOpenEnquire] = React.useState(false)
    const handleOpenEnquire = () => setOpenEnquire(true)
    const handleCloseEnquire = () => setOpenEnquire(false)
    const [selectedVehicle, setSelectedVehicle] = React.useState('')
    const [vehicleInfo, setVehicleInfo] = React.useState([])
    const list =
        filter === "All" ? carData : carData.filter((c) => c.segment === filter);

    return (
        <Box sx={{ py: { xs: 6, md: 4 }, bgcolor: "#f7f9fc" }}>
            <Container maxWidth="lg">
                {/* Heading */}
                <Heading title={title} subtitle={subtitle} />

                {/* Toggle */}
                {/* Responsive Toggle */}
                <Box
                    sx={{
                        // graceful horizontal scroll if there are many items
                        overflowX: "auto",
                        mx: { xs: -2, sm: 0 },            // bleed to edges on mobile
                        px: { xs: 2, sm: 0 },
                        "&::-webkit-scrollbar": { display: "none" },
                        scrollbarWidth: "none",
                    }}
                >
                    <Stack
                        direction="row"
                        justifyContent="center"
                        useFlexGap
                        flexWrap="wrap"                    // wrap on small screens
                        sx={{
                            gap: { xs: 1, sm: 1.25, md: 1.5 } // responsive spacing
                        }}
                    >
                        {filters?.map((t, index) => {
                            const active = filter === t;
                            return (
                                <Chip
                                    key={index}
                                    clickable
                                    onClick={() => setFilter(t)}
                                    label={t}
                                    // keep your active look, but make sizes responsive
                                    sx={{
                                        ...pillSx(active),
                                        px: { xs: 1.25, sm: 1.5, md: 1.75 },
                                        height: { xs: 30, sm: 32, md: 36 },
                                        borderRadius: 999,
                                        // responsive label sizing
                                        "& .MuiChip-label": {
                                            px: 0,
                                            fontWeight: 600,
                                            fontSize: { xs: 12, sm: 13, md: 14 },
                                        },
                                    }}
                                />
                            );
                        })}
                    </Stack>
                </Box>


                {/* Cards grid */}
                <Grid container spacing={4} sx={{ mt: 2 }}>
                    {list.map((car) => (
                        <Grid key={car.id} item xs={12} sm={6} md={4}>
                            <CarInvestmentCard
                                {...car}
                                FleetData={list}
                                setSelectedVehicle={setSelectedVehicle}
                                setVehicleInfo={setVehicleInfo}
                                vehicleInfo={vehicleInfo}
                                setContact={setContact}
                                selectedVehicle={selectedVehicle}
                                contact={contact}
                                setOpenEnquire={setOpenEnquire}
                                onEnquire={() => alert(`Enquiry for ${car.title}`)}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <EnquireFormModal
                open={openEnquire}
                setOpen={setOpenEnquire}
                onClose={handleCloseEnquire}
                fleetCard={list}
                contact={contact}
                setContact={setContact}
                selectedVehicle={selectedVehicle}
                setSelectedVehicle={setSelectedVehicle}
            />
        </Box>
    );
}

const pillSx = (active) => ({
    flexShrink: 0,
    fontWeight: 700,
    minWidth: "150px",
    borderRadius: "999px",
    px: { xs: 1.5, md: 2.5 },
    py: { xs: 1, md: 3 },
    fontSize: { xs: 14, md: 16 },
    background: active
        ? "linear-gradient(180deg, #75c4c5 0%, #0d8196 100%)"
        : "#fff",
    color: active ? "#fff" : "#000",
    "&:hover": {
        background: active
            ? "linear-gradient(180deg, #4bb6b4 0%, #249f9c 100%)"
            : "#f7f9f9",
    },
    "& .MuiChip-label": { px: 0, fontWeight: 700 },
});